// 지금 보고 있는 회사가 어디인지는 주소가 들고 있다.
//
//   /fin/            에르모어 (본사)
//   /fin/babyplus/   베이비플러스
//
// 세션이나 전역 상태에 담지 않는 이유가 있다. 담아 두면 회사를 바꿨을 때 열어 둔 다른
// 탭은 여전히 이전 회사 화면인데, 거기서 저장하면 바뀐 회사로 들어간다. 회계 데이터라
// 되돌리기도 어렵다. 주소에 있으면 탭마다 자기 회사를 들고 다니고, 북마크도 된다.
//
// 서버에는 X-Company 헤더로 보낸다(portalApi.js). 서버는 그걸 보고 어느 DB 에 붙을지
// 정하고, 볼 권한이 없는 회사면 막는다.

const 본사 = 'ermore'

// /fin/ 바로 아래의 첫 조각이 회사 코드다. 자산 경로(assets)는 회사일 리 없으니 뺀다.
const 회사아님 = new Set(['assets', 'index.html', 'favicon.ico'])

export function currentCompany() {
  const m = /^\/fin\/([a-z][a-z0-9_]*)(?:\/|$)/.exec(window.location.pathname)
  if (!m || 회사아님.has(m[1])) return 본사
  return m[1]
}

export function companyPath(code) {
  return code === 본사 ? '/fin/' : `/fin/${code}/`
}

// 회사를 바꾼다. 주소가 바뀌므로 페이지를 다시 열어 그 회사로 붙게 한다 -
// 화면만 갈아 끼우면 이미 받아 둔 다른 회사 데이터가 섞인다.
export function switchCompany(code) {
  window.location.href = companyPath(code)
}

export const HOME_COMPANY = 본사
